import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    Popover
} from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Card } from "components/Card/Card.jsx";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { hasPermission } from "helper/hasPermission";
import Confirmalertfordelete from "../../../ThemeComponents/confirmAlertForDelete";
import { Link, withRouter } from "react-router-dom";
import { brandActions } from "../../../../redux/actions/brand-actions";

// dropdown components //
import BrandsDropdown from "../BrandsDropdown";
import LookupJSON from "./LookupJSON";
import { helperFunctions as HF } from "../../../../helper/helperFunctions";
import { adminLabels } from "../../../../redux/constant/admin-label-constant";
import BrandsDropdownLinks from "../BrandsDropdownLinks";

var Modal = require("react-bootstrap-modal");

class LookupListing extends Component {
    constructor(props) {
        super(props);

        const user = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).result.user : undefined;
        let model_id;
        let model;
        if (user.model === 'App\\Customer' || user.model === 'App\\Brand') {
            model_id = user.model_id;
            model = this.props.match.params.model;
        }
        else {
            model_id = this.props.match.params.brandId;
            model = '';
        }

        this.state = {
            loggedInUserType: user.model,
            addModal: false,
            editModalState: false,
            sorted: "",
            filtered: "",
            pageSize: 10,
            brandId: this.props.match.params.brandId,
            showDropdown: this.props.match.params.brandId !== "all" ? false : true,
            tables: [
                {
                    brand: "Lucky",
                    table_name: "1AA",
                    sample_file: "7ASD2",
                    file_type: "CSV",
                    created_at: "Aug 29 2019",
                    value: 1
                }
            ],
            model_id: model_id,
            model: model,
        };
        this.callEditState = this.callEditState.bind(this);
        this.filterSearchHandle = this.filterSearchHandle.bind(this);
        this.handleStateSubmit = this.handleStateSubmit.bind(this);
    }
    handleStateSubmit(stateData, formType) {
        if (formType === "add") this.props.storeStateCall(stateData);
        else if (formType === "edit")
            this.props.editStateCall(stateData, this.props.editState.value);
    }

    filterSearchHandle(e) {
        this.setState({
            'filtered': e.target.value
        }, () => {
            this.refReactTable.fireFetchData()
        });
    }
    callEditState(id) {
        this.setState({
            editModalState: true
        });
        this.props.getStateCall(id);
    }

    deleteState = (id) => {
        this.props.deleteLookupDefinitionCall(id).then(res => {
            this.props.getBrandLookupDefinitionsPaginationCall(
                this.state.brandId,
                this.props.current_page,
                this.state.filtered,
                this.state.sorted,
                this.state.pageSize
            );
        });
    }
    deleteConfirm = (id) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete
                        typeName="Definition"
                        description="Are you sure to delete the definition?"
                        onClosePro={onClose}
                        deleteType={() => this.deleteState(id)}
                    />
                );
            }
        });
    }
    lookupDataDefinitionsPagination = (page, filter, sort, pageSize) => {
        this.setState({ pageSize: pageSize }, function () {
            this.props.getBrandLookupDefinitionsPaginationCall(
                this.state.brandId,
                page,
                filter,
                sort,
                pageSize
            );
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.match.params.model !== prevProps.match.params.model) {
            window.location.reload();
        }

        if (this.props.match.params.brandId !== 'all' && this.props.match.params.brandId !== prevProps.match.params.brandId) {
            this.props.getBrandLookupDefinitionsPaginationCall(this.props.match.params.brandId, 1, this.state.filtered, this.state.sorted, this.state.pageSize);
        }
    }

    getFullState = state => {
        this.setState(
            prevState => ({
                brandId: state.model_id
            }),
            (state = this.state) => {
                const { brandId, filtered } = state;
                if (brandId !== 'all') {
                    this.props.getBrandLookupDefinitionsPaginationCall(
                        brandId,
                        1,
                        filtered,
                        this.state.sorted,
                        this.state.pageSize
                    );
                }
            }
        );
    };

    viewJSON = (data) => {
        this.setState({
            ...this.state,
            jsonData: data,
            addModal: true,
        })
    }

    getModelId = (id) => {
        this.setState({
            model_id: id,
            linkClicked: true,
        }, () => {
            this.props.history.push(`/Admin/brand/${this.state.model_id}/lookup-listing`);
        })
    }

    render() {
        const { filtered } = this.state;
        const { pages, loading, lookupDefinitionPaginated } = this.props;
        const columns = [
            {
                Header: "Lookup Tables Listing",
                headerClassName: "headerPagination",
                columns: [
                    {
                        Header: "Brand",
                        accessor: "brand",
                        className: "action-center"
                    },
                    {
                        Header: "Table Name",
                        accessor: "table_name",
                        className: "action-center"
                    },
                    {
                        Header: "Feed File Name",
                        accessor: "table_name",
                        className: "action-center",
                        Cell: ({ value, original }) => (
                            <div>
                                {
                                    value.replace('lookup_', '').replace(`_${original.brand_short_code}`, '') + '.' + original.sample_file_type
                                }
                            </div>
                        )
                    },
                    {
                        Header: "Sample File Name",
                        accessor: "sample_file_original_name",
                        className: "action-center"
                    },
                    {
                        Header: "File Type",
                        accessor: "sample_file_type",
                        className: "action-center"
                    },
                    {
                        Header: "Created Date",
                        accessor: "created_at",
                        className: "action-center"
                    },
                    {
                        Header: "Attributes (JSON)",
                        accessor: "id",
                        sortable: false,
                        Cell: ({ value, original }) => (
                            <div>
                                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission('manage-brand-lookup-tabeles') ? 'View JSON' : adminLabels.DONT_ALLOW}</Popover>}>
                                    <span>
                                        {
                                            hasPermission('manage-brand-lookup-tabeles') &&
                                            /* <Link
                                                to={{
                                                    pathname: `/Admin/brand/${this.state.brandId}/lookupJSON`,
                                                    state: { original }
                                                }}
                                                target='_blank'
                                                onClick={() => { localStorage.setItem('jsonData', JSON.stringify(original)) }}
                                                className="viewIcon orderDetailsAction"
                                            ></Link> */
                                            <button className="viewIcon orderDetailsAction" onClick={() => { this.viewJSON(original) }}></button>
                                        }
                                        {
                                            !hasPermission('manage-brand-lookup-tabeles') &&
                                            <button type='button' className="viewIcon orderDetailsAction button_disabled" >&nbsp;</button>
                                        }
                                    </span>
                                </OverlayTrigger>
                            </div>
                        )
                    },
                    {
                        Header: "Actions",
                        accessor: "id",
                        Cell: ({ value, original }) => (
                            <div>
                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={<Popover id="tooltip">{hasPermission('manage-brand-lookup-tabeles') ? 'Edit Definition' : adminLabels.DONT_ALLOW}</Popover>}
                                >
                                    <span>
                                        {hasPermission("manage-brand-lookup-tabeles") && (
                                            /* <button type='button' className="editIcon orderDetailsAction" onClick={() => { }}>&nbsp;</button> */
                                            <Link
                                                to={{
                                                    pathname: `/Admin/brand/${this.state.brandId}/add-lookup-table`,
                                                    state: { original }
                                                }}
                                                className="editIcon orderDetailsAction"
                                            ></Link>
                                        )}
                                        {!hasPermission("manage-brand-lookup-tabeles") && (
                                            <button
                                                type="button"
                                                className="editIcon orderDetailsAction button_disabled"
                                            >
                                                &nbsp;
                                            </button>
                                        )}
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={<Popover id="tooltip">{hasPermission('manage-brand-lookup-tabeles') ? 'Delete Definition' : adminLabels.DONT_ALLOW}</Popover>}
                                >
                                    <span>
                                        {hasPermission("manage-brand-lookup-tabeles") && (
                                            <button
                                                type="button"
                                                className="deleteIcon orderDetailsAction"
                                                onClick={() =>
                                                    this.deleteConfirm(
                                                        value
                                                    )
                                                }
                                            >
                                                &nbsp;
                                            </button>
                                        )}
                                        {!hasPermission("manage-brand-lookup-tabeles") && (
                                            <button
                                                type="button"
                                                className="deleteIcon orderDetailsAction button_disabled"
                                            >
                                                &nbsp;
                                            </button>
                                        )}
                                    </span>
                                </OverlayTrigger>
                            </div>
                        ),
                        className: "action-center",
                        sortable: false
                    }
                ]
            }
        ];

        return (
            <React.Fragment>

                <div className="content">
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Card
                                    ctTableResponsive
                                    content={
                                        <div>
                                            {this.state.showDropdown && (
                                                <div
                                                    className="col-md-4 pull-right"
                                                >
                                                    <BrandsDropdown
                                                        onReturnFullState={this.getFullState}
                                                        stateProp={this.state}
                                                        selectedCustomer={this.state.model_id}
                                                        modelProp={this.state.loggedInUserType}
                                                    />
                                                </div>
                                            )}
                                            {!this.state.showDropdown &&
                                                <div
                                                    className="col-md-4 pull-right"
                                                >
                                                    <BrandsDropdownLinks
                                                        returnModelId={this.getModelId}
                                                        componentProp='LookupListing'
                                                    />
                                                </div>
                                            }
                                            <Grid fluid>
                                                <Row>
                                                    <Col md={12}>
                                                        <h3
                                                            style={{
                                                                textAlign:
                                                                    "center",
                                                                fontWeight:
                                                                    "500"
                                                            }}
                                                        >
                                                            Lookup Data
                                                            Definition
                                                        </h3>
                                                    </Col>

                                                    <Col md={12}>
                                                        <div
                                                            className="flexElem flexResponsive mt-xlg"
                                                            style={{
                                                                alignItems:
                                                                    "flex-start",
                                                                justifyContent:
                                                                    "space-between"
                                                            }}
                                                        >
                                                            <div className="block">
                                                                {
                                                                    hasPermission("list-create") && (
                                                                        this.props.match.params.brandId === 'all' && this.state.brandId && this.state.brandId !== 'all'
                                                                    )  || this.props.match.params.brandId !== 'all'
                                                                    ? (
                                                                        <Link
                                                                            to={`/Admin/brand/${this.props.match.params.brandId === 'all'? this.state.brandId : this.props.match.params.brandId}/add-lookup-table`}
                                                                            className={[
                                                                                "customBtn btnBlue"
                                                                            ]}
                                                                            name="Add Table"
                                                                        >
                                                                            Add
                                                                            Table
                                                                        </Link>
                                                                    ) :
                                                                    (
                                                                        null
                                                                    )
                                                                }
                                                            </div>

                                                            <div className="custom-search-input">
                                                                <FormInputs
                                                                    ncols={[
                                                                        "col-md-12"
                                                                    ]}
                                                                    onChange={
                                                                        this
                                                                            .filterSearchHandle
                                                                    }
                                                                    proprieties={[
                                                                        {
                                                                            type:
                                                                                "text",
                                                                            bsClass:
                                                                                "form-control",
                                                                            placeholder:
                                                                                "Search Lookups",
                                                                            onChange: this
                                                                                .filterSearchHandle,
                                                                            name:
                                                                                "filter"
                                                                        }
                                                                    ]}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col
                                                        md={12}
                                                        className="mt-xlg"
                                                    >
                                                        <ReactTable
                                                            noDataText="No lookup definitions found"
                                                            data={
                                                                lookupDefinitionPaginated
                                                            }
                                                            pages={pages}
                                                            loading={loading}
                                                            columns={columns}
                                                            defaultPageSize={10}
                                                            className="-striped listing responsive"
                                                            pageData={
                                                                this
                                                                    .lookupDataDefinitionsPagination
                                                            }
                                                            ref={(refReactTable) => {this.refReactTable = refReactTable;}}
                                                            manual
                                                            onFetchData={(state, instance) => {
                                                                var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                                                                state.pageData(state.page + 1, this.state.filtered, sort, state.pageSize);
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Grid>
                                            {
                                                <Modal className='custom_lg' show={this.state.addModal} onHide={HF.closeModal.bind(this, "addModal")} aria-labelledby="ModalHeader"
                                                >
                                                    <Modal.Header closeButton>
                                                        <Modal.Title id='ModalHeader' className="headerTitle">JSON Attributes</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <LookupJSON
                                                                    closeModel={HF.closeModal.bind(this, "addModal")}
                                                                    formTypePro="add"
                                                                    jsonData={this.state.jsonData}
                                                                    handleSubmit={this.handRulesSubmitForm}
                                                                    componentPro={'Lookup'}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                            }
                                        </div>
                                    }
                                />
                            </Col>
                        </Row>
                    </Grid>
                </div>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getBrandLookupDefinitionsPaginationCall: (
            id,
            page,
            filter,
            sort,
            pageSize
        ) => {
            let resource_id = "";
            if (id !== undefined) {
                resource_id = id;
            } else {
                resource_id = "all";
            }
            dispatch(
                brandActions.getBrandLookupDefinitionsPagination(
                    resource_id,
                    page,
                    filter,
                    sort,
                    pageSize
                )
            );
        },
        deleteLookupDefinitionCall: (id) => { return dispatch(brandActions.deleteLookupDefinition(id)) },
    };
};

function mapStateToProps(state) {
    const {
        loading,
        pages,
        current_page,
        lookupDefinitionPaginated
    } = state.brandReducer;
    return {
        loading,
        pages,
        current_page,
        lookupDefinitionPaginated
    };
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(LookupListing)
);



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/Lookup Definition/LookupListing.jsx